/** Строки десктоп-вёрстки меню (ключ → язык → текст); подключены в LocalizationService */
export const DESKTOP_TRANSLATIONS: Record<string, Record<string, string>> = {
  events: {
    ru: 'События',
    de: 'Veranstaltungen',
    fr: 'Événements',
    tr: 'Etkinlikler',
    sr: 'Događaji',
    en: 'Events'
  },
  contactsAndDetails: {
    ru: 'Контакты и реквизиты',
    de: 'Kontakt und Impressum',
    fr: 'Contacts et mentions',
    tr: 'İletişim ve bilgiler',
    sr: 'Kontakti i podaci',
    en: 'Contacts and details'
  },
  copyLink: {
    ru: 'Скопировать ссылку',
    de: 'Link kopieren',
    fr: 'Copier le lien',
    tr: 'Bağlantıyı kopyala',
    sr: 'Kopiraj link',
    en: 'Copy link'
  },
  linkCopied: {
    ru: 'Ссылка скопирована',
    de: 'Link kopiert',
    fr: 'Lien copié',
    tr: 'Bağlantı kopyalandı',
    sr: 'Link je kopiran',
    en: 'Link copied'
  },
  itemLink: {
    ru: 'Ссылка на блюдо',
    de: 'Link zum Gericht',
    fr: 'Lien vers le plat',
    tr: 'Ürün bağlantısı',
    sr: 'Link do jela',
    en: 'Link to this item'
  },
  orderAtVenue: {
    ru: 'Заказ — в заведении.',
    de: 'Bestellung vor Ort.',
    fr: 'Commande sur place.',
    tr: 'Sipariş mekânda.',
    sr: 'Poručivanje u lokalu.',
    en: 'Order at the venue.'
  },
  orderAtVenueHint: {
    ru: 'Отсканируйте QR-код на столе, и блюдо можно будет добавить в заказ.',
    de: 'Scannen Sie den QR-Code am Tisch, um das Gericht zu bestellen.',
    fr: 'Scannez le QR code sur la table pour ajouter le plat à votre commande.',
    tr: 'Siparişe eklemek için masadaki QR kodu okutun.',
    sr: 'Skenirajte QR kod na stolu da biste dodali jelo u porudžbinu.',
    en: 'Scan the QR code on your table to add it to your order.'
  },
  addAtOrder: {
    ru: 'можно добавить при заказе',
    de: 'bei der Bestellung wählbar',
    fr: 'à ajouter lors de la commande',
    tr: 'sipariş sırasında eklenebilir',
    sr: 'može se dodati pri porudžbini',
    en: 'can be added when ordering'
  },
  per100: {
    ru: 'на 100',
    de: 'je 100',
    fr: 'pour 100',
    tr: '100 başına',
    sr: 'na 100',
    en: 'per 100'
  },
  perServing: {
    ru: 'на порцию',
    de: 'pro Portion',
    fr: 'par portion',
    tr: 'porsiyon başına',
    sr: 'po porciji',
    en: 'per serving'
  },
  ctaTitle: {
    ru: 'Такое меню — у вашего заведения за вечер',
    de: 'So ein Menü für Ihr Lokal – an einem Abend',
    fr: 'Ce menu pour votre lieu — en une soirée',
    tr: 'Mekânınız için böyle bir menü — bir akşamda',
    sr: 'Ovakav meni za vaš lokal — za jedno veče',
    en: 'This menu for your venue — in one evening'
  },
  ctaText: {
    ru: 'Меню по QR, заказы с телефона гостя и вызов официанта. Начните с бесплатного тарифа.',
    de: 'QR-Speisekarte, Bestellungen vom Smartphone des Gastes und Kellnerruf. Starten Sie kostenlos.',
    fr: 'Menu QR, commandes depuis le téléphone du client et appel du serveur. Commencez gratuitement.',
    tr: 'QR menü, misafirin telefonundan sipariş ve garson çağırma. Ücretsiz planla başlayın.',
    sr: 'QR meni, porudžbine sa telefona gosta i pozivanje konobara. Počnite besplatno.',
    en: 'QR menu, orders from the guest’s phone and waiter calls. Start with the free plan.'
  },
  edimApp: {
    ru: 'Приложение Edim',
    de: 'Edim-App',
    fr: 'Application Edim',
    tr: 'Edim uygulaması',
    sr: 'Aplikacija Edim',
    en: 'Edim app'
  },
  edimAppText: {
    ru: 'Меню, столы, заказы, персонал и уведомления — с телефона.',
    de: 'Menü, Tische, Bestellungen, Team und Benachrichtigungen – vom Smartphone.',
    fr: 'Menu, tables, commandes, équipe et notifications — depuis le téléphone.',
    tr: 'Menü, masalar, siparişler, ekip ve bildirimler — telefondan.',
    sr: 'Meni, stolovi, porudžbine, osoblje i obaveštenja — sa telefona.',
    en: 'Menu, tables, orders, staff and notifications — from your phone.'
  },
  downloadOn: {
    ru: 'Загрузите в',
    de: 'Laden im',
    fr: 'Télécharger dans',
    tr: 'İndirin',
    sr: 'Preuzmite na',
    en: 'Download on the'
  },
  getItOn: {
    ru: 'Доступно в',
    de: 'Jetzt bei',
    fr: 'Disponible sur',
    tr: 'Hemen edinin',
    sr: 'Nabavite na',
    en: 'Get it on'
  },
  openInBrowser: {
    ru: 'Открыть в браузере',
    de: 'Im Browser öffnen',
    fr: 'Ouvrir dans le navigateur',
    tr: 'Tarayıcıda aç',
    sr: 'Otvori u pregledaču',
    en: 'Open in browser'
  },
  soon: {
    ru: 'Скоро',
    de: 'Bald verfügbar',
    fr: 'Bientôt',
    tr: 'Yakında',
    sr: 'Uskoro',
    en: 'Coming soon'
  },
  privacyPolicy: {
    ru: 'Политика конфиденциальности',
    de: 'Datenschutzerklärung',
    fr: 'Politique de confidentialité',
    tr: 'Gizlilik politikası',
    sr: 'Politika privatnosti',
    en: 'Privacy policy'
  },
  address: {
    ru: 'Адрес',
    de: 'Adresse',
    fr: 'Adresse',
    tr: 'Adres',
    sr: 'Adresa',
    en: 'Address'
  },
  phone: {
    ru: 'Телефон',
    de: 'Telefon',
    fr: 'Téléphone',
    tr: 'Telefon',
    sr: 'Telefon',
    en: 'Phone'
  },
  // Справочник аллергенов в подвале — текст из приложения Edim (allergens.reference),
  // без фразы о том, где их видит гость
  allergensReference: {
    ru: 'В ЕС эти 14 аллергенов обязательно указываются, если входят в блюдо или напиток — в том числе в соус, панировку, тесто или масло для жарки. За точность отвечает заведение.',
    de: 'In der EU müssen diese 14 Allergene angegeben werden, wenn sie in einem Gericht oder Getränk enthalten sind – auch in Soße, Panade, Teig oder Frittierfett. Für die Richtigkeit ist der Betrieb verantwortlich.',
    fr: "Dans l'UE, ces 14 allergènes doivent être indiqués lorsqu'ils sont présents dans un plat ou une boisson — y compris la sauce, la panure, la pâte ou l'huile de friture. L'établissement est responsable de leur exactitude.",
    tr: "AB'de bu 14 alerjen bir yemek veya içecekte — sos, pane, hamur ya da kızartma yağı dahil — bulunduğunda belirtilmelidir. Doğruluktan işletme sorumludur.",
    sr: 'U EU ovih 14 alergena mora biti navedeno ako se nalaze u jelu ili piću — uključujući sos, pohovanje, testo ili ulje za prženje. Za tačnost odgovara objekat.',
    en: 'In the EU these 14 allergens must be declared when they are in a dish or drink — including sauces, breading, dough or frying oil. The venue is responsible for accuracy.'
  },
  allergensRegulation: {
    ru: 'Регламент (ЕС) № 1169/2011, Приложение II',
    de: 'Verordnung (EU) Nr. 1169/2011, Anhang II',
    fr: 'Règlement (UE) n° 1169/2011, annexe II',
    tr: '(AB) 1169/2011 sayılı Tüzük, Ek II',
    sr: 'Uredba (EU) br. 1169/2011, Prilog II',
    en: 'Regulation (EU) No 1169/2011, Annex II'
  },
};

/** Названия языков меню — в переключателе языка, на самом языке */
export const LANGUAGE_NAMES: Record<string, string> = {
  ru: 'Русский',
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  sr: 'Srpski',
  tr: 'Türkçe',
};
